var map = {
	"./breadfriend-logo.svg": 19,
	"./cabbage.png": 42,
	"./carrot.png": 43,
	"./cauliflower.png": 44,
	"./chard.png": 45,
	"./corn.png": 46,
	"./cucumber.png": 47,
	"./eggplant.png": 48,
	"./garlic.png": 49,
	"./green-peppers.png": 50,
	"./iceburg-lettuce.png": 51,
	"./onion.png": 52,
	"./potato.png": 53,
	"./tomato.png": 54,
	"./zuccinni.png": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;